import React from "react"
import {
  Box, Flex, Text, VStack,
} from "@chakra-ui/react"
import Link from "components/elements/Link"
import { DioboxEvent } from "sharedTypes"
import { GUEST_PORTAL_HELP_ARTICLE_LINK } from "utilities/externalLinks"
import CopyToClipboard from "components/elements/CopyToClipboard"
import GoogleAnalyticsForm, { Variant } from "components/GoogleAnalyticsForm"
import PageContent from "components/layout/PageContent"
import TitleWithSubtitle from "../TitleWithSubtitle"
import GuestActionsForm from "./GuestActionsForm"

type Props = {
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const PortalSetup = ({
  event,
  updateEvent,
}: Props) => {
  const guestPortalUrl = event.urls?.portal

  return (
    <PageContent noPadding>
      <VStack align="flex-start" spacing={16}>
        <Box>
          <TitleWithSubtitle title="Guest Portal URL" mb={2} />
          {guestPortalUrl && (
            <Flex align="center" gap={3}>
              <Link isExternal href={guestPortalUrl}><Text fontWeight="bold" fontSize="lg">{guestPortalUrl}</Text></Link>
              <CopyToClipboard text={guestPortalUrl} size="xs" variant="outline">Copy</CopyToClipboard>
            </Flex>
          )}
          <Box
            bg="white"
            borderWidth={1}
            borderRadius="xl"
            px={6}
            py={4}
            mt={6}
          >
            <VStack align="flex-start" spacing={4}>
              <Text fontWeight="semibold" fontSize="lg">What is the Guest Portal?</Text>
              <Text>The Guest Portal is a collection of features that
                allows your attendees to interact with your event,
                including registration pages and email
                communication.
              </Text>
              <Text>
                To learn more, see {" "}
                <Link href={GUEST_PORTAL_HELP_ARTICLE_LINK} isExternal>
                  Guest Portal Help Article
                </Link>.
              </Text>
            </VStack>
          </Box>
        </Box>
        <Box>
          <TitleWithSubtitle
            title="Guest Actions"
            subtitle="Choose how guests can complete and update their registration."
          />
          <GuestActionsForm event={event} updateEvent={updateEvent} />
        </Box>
        <GoogleAnalyticsForm
          googleAnalyticsMeasurementId={event.googleAnalyticsMeasurementId}
          updateEvent={updateEvent}
          variant={Variant.FormsGuestPortal}
        />
      </VStack>
    </PageContent>
  )
}

export default PortalSetup
